import { FC } from 'react';

type Props = {
  size?: number,
  className?: string,
};

// Stroke-based chain-link glyph; inherits the parent's text colour via
// currentColor. Marks a project linked to Next Project (ACC-711).
const LinkOutlineIcon: FC<Props> = ({ size = 15, className }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12.5 10a5 5 0 1 0 0 10h4a5 5 0 0 0 3.55-8.52"></path>
    <path d="M11.5 14a5 5 0 1 0 0-10h-4a5 5 0 0 0-3.55 8.52"></path>
  </svg>
);

export default LinkOutlineIcon;
